import { 
    createRouteRef, 
    createSubRouteRef 
  } from '@backstage/core-plugin-api';
  import { EpDevPPluginIds } from '@solace-labs/backstage-plugin-ep-devp-common';
  import { EpDevPConsumerAppsApiRoutesFactory } from '@solace-labs/backstage-plugin-ep-devp-consumer-apps-common';
  
  export const rootRouteRef = createRouteRef({
    id: `${EpDevPPluginIds.EpDevPConsumerAppsPluginId}:route:root`,
  });
  
  export const consumerAppsListRouteRef = createSubRouteRef({
    id: `${EpDevPPluginIds.EpDevPConsumerAppsPluginId}:route:list`,
    parent: rootRouteRef,
    path: '/:organizationId',
  });
  EpDevPConsumerAppsApiRoutesFactory.validateRoute({
    pluginId: EpDevPPluginIds.EpDevPConsumerAppsPluginId,
    actualRoute: consumerAppsListRouteRef.path,
    expectedRoute: EpDevPConsumerAppsApiRoutesFactory.getSubRouteList()
  });
  
  export const consumerAppsViewRouteRef = createSubRouteRef({
    id: `${EpDevPPluginIds.EpDevPConsumerAppsPluginId}:route:view`,
    parent: rootRouteRef,
    path: '/:organizationId/:domainId/:assetId/*'
  });
  EpDevPConsumerAppsApiRoutesFactory.validateRoute({
    pluginId: EpDevPPluginIds.EpDevPConsumerAppsPluginId,
    actualRoute: consumerAppsViewRouteRef.path,
    expectedRoute: `${EpDevPConsumerAppsApiRoutesFactory.getSubRouteDomainById()}/*`
  });
  
  export const consumerAppsRequestAccessRouteRef = createSubRouteRef({
    id: `${EpDevPPluginIds.EpDevPConsumerAppsPluginId}:route:request-access`,
    parent: rootRouteRef,
    path: '/:organizationId/:domainId/:assetId/request-access'
  });
  EpDevPConsumerAppsApiRoutesFactory.validateRoute({
    pluginId: EpDevPPluginIds.EpDevPConsumerAppsPluginId,
    actualRoute: consumerAppsRequestAccessRouteRef.path,
    expectedRoute: `${EpDevPConsumerAppsApiRoutesFactory.getSubRouteDomainById()}/request-access`
  });
  
  export const consumerAppsCreateRouteRef = createSubRouteRef({
    id: `${EpDevPPluginIds.EpDevPConsumerAppsPluginId}:route:create`,
    parent: rootRouteRef,
    path: '/:organizationId/create'
  });
  EpDevPConsumerAppsApiRoutesFactory.validateRoute({
    pluginId: EpDevPPluginIds.EpDevPConsumerAppsPluginId,
    actualRoute: consumerAppsCreateRouteRef.path,
    expectedRoute: `${EpDevPConsumerAppsApiRoutesFactory.getSubRouteBase()}/create`
  });
  
  export const consumerAppsUpgradeProductRegistrationRouteRef = createSubRouteRef({
    id: `${EpDevPPluginIds.EpDevPConsumerAppsPluginId}:route:upgrade-product-registration`,
    parent: rootRouteRef,
    path: '/:organizationId/:domainId/:assetId/:accessRequestId/upgrade'
  });
  EpDevPConsumerAppsApiRoutesFactory.validateRoute({
    pluginId: EpDevPPluginIds.EpDevPConsumerAppsPluginId,
    actualRoute: consumerAppsUpgradeProductRegistrationRouteRef.path,
    expectedRoute: `${EpDevPConsumerAppsApiRoutesFactory.getSubRouteDomainById()}/:accessRequestId/upgrade`
  });
  